/**
 * The context the provider fills and the hooks read.
 *
 * Its own module so `ObserverProvider.tsx` can export only a component and
 * `store.ts` only hooks — React Fast Refresh gives up on a file that exports
 * both, which in development means every socket change forces a full reload.
 */

import { createContext, useContext } from 'react'

import type { Observer } from '../api/socket'

export const ObserverContext = createContext<Observer | null>(null)

/** The tab's socket. Throws outside a provider rather than failing silently. */
export function useObserverInstance(): Observer {
  const observer = useContext(ObserverContext)
  if (!observer) throw new Error('useObserver must be used inside an ObserverProvider')
  return observer
}
